import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const incomeStatementFilterList = (permissions, options = {}) => {
  const { includeViewMode = true } = options;
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      //FIXME: semua DateInput tidak bisa di tambah resettable
      // resettable
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
  ];
  if (includeViewMode) {
    defaultFilter.unshift(
      <SelectInput
        alwaysOn
        source="view_mode"
        variant="outlined"
        margin="dense"
        size="small"
        label="View Mode"
        disabled
        emptyText={false}
        choices={[
          { id: "grouped", name: "Grouped" },
          { id: "detail", name: "Detail" },
        ]}
      />
    );
  }
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default incomeStatementFilterList;
